import { recordPath, recordRoute } from '@/shared/registry'

/** Where the course custom field pages live. */
export const courseCustomFieldsPath = '/catalog/course-custom-fields'
export const createCourseCustomFieldPath = `${courseCustomFieldsPath}/new`
export const courseCustomFieldRoute = recordRoute('catalog', 'course-custom-fields')
export const editCourseCustomFieldRoute = `${courseCustomFieldRoute}/edit`

/** A course custom field's details page. */
export function courseCustomFieldPath(id: string): string {
  return recordPath('catalog', 'course-custom-fields', id)
}

/** A course custom field's edit page. */
export function editCourseCustomFieldPath(id: string): string {
  return `${courseCustomFieldPath(id)}/edit`
}

/** The base of Course Custom Field Details' slots (`detailsSlots`). */
export const courseCustomFieldDetailsSlot = 'catalog.course-custom-field-details'

/** The API's course custom field endpoints: a GET finds them, a POST creates one. */
export const courseCustomFieldsApi = '/catalog/v1/course-custom-fields'

export function courseCustomFieldApi(id: string): string {
  return `${courseCustomFieldsApi}/${encodeURIComponent(id)}`
}

/** The enabled fields a new course of the organization has, as Create Course fills them in. */
export function availableCourseCustomFieldsApi(organizationId: string): string {
  return `${courseCustomFieldsApi}/available/${encodeURIComponent(organizationId)}`
}

/** A course's custom fields and values: GET reads them, PUT replaces the values at the course's version. */
export function courseCustomFieldValuesApi(courseId: string): string {
  return `/catalog/v1/courses/${encodeURIComponent(courseId)}/custom-fields`
}

/** What each definition action needs, by the field's managing organization; a course's values go with the course. */
export const readCourseCustomFieldsPermission = 'catalog.course-custom-fields.read'
export const writeCourseCustomFieldsPermission = 'catalog.course-custom-fields.write'
